import React from 'react'
import './style.css'
import { Slider } from 'antd'

const RangePicker = ({ rangePickerValueHandler, rangePickerValue }) => {

    const sliderValueHandler = (value) => {
        rangePickerValueHandler(value)
    }

    const marks = {
        20: '20',
        40: '40',
        60: '60',
        80: '80',
        100: '100'
    };

    return (
        <Slider
            range
            step={null}  // Disable stepping to allow only mark values
            marks={marks}
            value={rangePickerValue}
            defaultValue={[20]}
            min={20}
            className='font-semibold'
            onChange={(value) => sliderValueHandler(value)}
        />
    )
}

export default RangePicker